export class OriginMetadata {
  constructor(
    public origin: string,
    public OriginStartTime: string,
  ) {}
}
